import { render } from "./AllView.vue?vue&type=template&id=05c63a79"
import script from "./AllView.vue?vue&type=script&lang=js"
export * from "./AllView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__